import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { PageProps } from '@/types/PageProps';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import AccessDenied from '@/components/_common/AccessDenied';
import EmailSettingsCrmForm from './EmailSettingsCrmForm';

function EmailSettingsCrmPage({ route }: PageProps) {
  const intl = useIntl();

  if (
    !hasPermissions([
      Authorities.CONFIGURATION_USER_MATRIX_CRM_SETTINGS_READ,
      Authorities.CONFIGURATION_MATRIX_SETTINGS,
    ])
  ) {
    <AccessDenied />;
  }

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div className="page">
        <EmailSettingsCrmForm />
      </div>
    </>
  );
}

export default EmailSettingsCrmPage;
